export enum YES_NO {
  yes = 'yes',
  no = 'no'
}
export interface CallMeFormState {
  name: string;
  number: string;
  day?: DayType | '';
  time?: { label: string; value: Date } | '';
  formErrors: {
    numValidity: 'VALID' | 'EMPTY' | 'INVALID';
    nameInvalid: boolean;
  };
  isCustomer: string;
  callMeActionStatusMessage: string;
  callMeActionStatus:
    | 'initial'
    | 'loading'
    | 'submittedSuccessfully'
    | 'submittedFailure';
}

export type DayType = {
  label: string;
  value: number;
  dateValue: Date;
};

export enum CallMeActionKind {
  SET_LOADING = 'SET_LOADING',
  SET_SUCCESS = 'SET_SUCCESS',
  SET_FAILURE = 'SET_FAILURE',
  SELECT_CUSTOMER_RELATIONSHIP = 'SELECT_CUSTOMER_RELATIONSHIP',
  ENTER_NAME = 'ENTER_NAME',
  ENTER_NUM = 'ENTER_NUM',
  CHOOSE_DAY = 'CHOOSE_DAY',
  CHOOSE_TIME = 'CHOOSE_TIME',
  VALIDATE_ENTER_NUM = 'VALIDATE_ENTER_NUM'
}

export type CallMeAction = {
  type: CallMeActionKind;
  payload: any;
};

export interface CallMeAppProps {
  additionalDataUrl: string | null | undefined;
}

export interface TimeslotOption {
  label: string;
  value: Date;
}

export interface QueueDetailsType {
  errand: string;
  menuchoice: string;
  entrance: string;
}

export type WorkingDays =
  | 'MANDAG'
  | 'TIRSDAG'
  | 'ONSDAG'
  | 'TORSDAG'
  | 'FREDAG';
export interface WorkingHours {
  [key: string]: string;
}

export interface EnonicDataType {
  hide_widget?: string; // Format of value should be <widget1>,<widget2> (Eg: call-now,call-later)
  main_header?: string;
  call_me_header?: string;
  call_me_later_header?: string;
  logo?: string; // Builders component name for the logo
  expanded_widgets?: string; // Format of value should be <widget1>,<widget2> (Eg: call-now,call-later)
  lunch_break: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 12-14
  open_hours: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 9-17
  number_of_days_open?: string; // Format should be a number (Eg: 5). Making the type to string as Enonic config will return a string value.
  open_hours_MANDAG: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 9-17
  open_hours_TISDAG: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 9-17
  open_hours_ONSDAG: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 9-17
  open_hours_TORSDAG: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 9-17
  open_hours_FREDAG: string; // Format of value should be <starttime>-<endtime> (24Hrs format). Eg: 9-17
  now_queue_test: string; // Format of value should be <errand>|<menuchoice>|<entrance>
  now_queue_prod: string; // Format of value should be <errand>|<menuchoice>|<entrance>
  later_queue_test: string; // Format of value should be <errand>|<menuchoice>|<entrance>
  later_queue_prod: string; // Format of value should be <errand>|<menuchoice>|<entrance>
}
